@if (view$ | async; as view) {
  @if (view.src) {
    <pcp-emm-iframe [iframeSrc]="view.src"></pcp-emm-iframe>
  } @else if (view.unavailable) {
    <p *transloco="let t" class="vdo-element__unavailable">
      {{ t('vdoElement.unavailable') }}
    </p>
  }
}
